export const FETCH_FILTER_DATA = 'FETCH_FILTER_DATA';
export const FETCH_FILTER_DATA_FAILURE = 'FETCH_FILTER_DATA_FAILURE';
export const TOGGLE_FILTER_ITEM = 'TOGGLE_FILTER_ITEM';
export const CREATE_OR_UPDATE_FILTER_ITEM = 'CREATE_OR_UPDATE_FILTER_ITEM';
export const TOGGLE_SHOW_FILTER = 'TOGGLE_SHOW_FILTER';
export const CLEAR_ALL_FILTERS = 'CLEAR_ALL_FILTERS';
export const GET_ALL_FILTERS = 'GET_ALL_FILTERS';
export const IS_SHOW_ITEMS_COUNT = 'IS_SHOW_ITEMS_COUNT';
